import { isProxy, toRaw } from 'vue'
import { useUserStore } from '.'

export const getHideExpinetLeaveWarningArray = (): string[]  => {
  const userStore = useUserStore()

  if (isProxy(userStore.hideExpinetLeaveWarningArray)) {
    return toRaw(userStore.hideExpinetLeaveWarningArray)
  }

  return userStore.hideExpinetLeaveWarningArray
}

export default {
  getHideExpinetLeaveWarningArray,
}